// client/src/utils/cardUtils.js

export const getCardImageUrl = (cardId, element) => {
  try {
    // Art généré (WebP ~150 Ko) servi par l'API statique
    return `/api/static/images/cards/${cardId}.webp`;
  } catch (error) {
    return getElementImageUrl(element);
  }
};

export const getElementImageUrl = (element) => {
  const elementMap = {
    'FIRE': '/api/static/images/elements/fire.svg',
    'WATER': '/api/static/images/elements/water.svg',
    'EARTH': '/api/static/images/elements/earth.svg',
    'AIR': '/api/static/images/elements/air.svg',
    'LIGHT': '/api/static/images/elements/light.svg',
    'DARK': '/api/static/images/elements/dark.svg',
    'RAINBOW': '/api/static/images/elements/rainbow.svg'
  };

  return elementMap[element] || '/api/static/images/elements/fire.svg';
};

// Dors de carte cosmétiques : un seul dos actif par joueur.
// RÈGLE ANTI-INFÉRENCE : le défaut est le dos NEUTRE — le dos d'un deck ne
// révèle jamais son contenu. Les dos élémentaux sont des cosmétiques profil.
export const getCardBackImageUrl = (element) => {
  const defaultBackImage = '/api/static/images/card-backs/neutral.webp';

  if (!element || element === 'default' || element === 'DEFAULT') {
    return defaultBackImage;
  }

  const elementValue = typeof element === 'string' ? element.toUpperCase() : element;
  const cardBackMap = {
    'FIRE': '/api/static/images/card-backs/fire.webp',
    'WATER': '/api/static/images/card-backs/water.webp',
    'EARTH': '/api/static/images/card-backs/earth.webp',
    'AIR': '/api/static/images/card-backs/neutral.webp',
    'LIGHT': '/api/static/images/card-backs/light.webp',
    'DARK': '/api/static/images/card-backs/dark.webp',
    'RAINBOW': '/api/static/images/card-backs/rainbow.webp'
  };

  return cardBackMap[elementValue] || defaultBackImage;
};
